import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/ministry-partnership")({
  loader: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
